import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import CartPage from "@saleor/createOrder/components/CartPage";
import {
  CartCustomerQueryParams,
  CartDetailCustomerSortField,
  CartDetailSortField,
  CartQueryParams,
  createOrderUrl
} from "@saleor/createOrder/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  () => ({
    header: {
      marginBottom: 36
    }
  }),
  { name: "CartView" }
);

const CartView: React.FC<any> = () => {
  const intl = useIntl();
  const classes = useStyles();
  const navigate = useNavigator();
  const qs = parseQs(location.search.substr(1));
  const params: CartQueryParams = asSortParams(
    qs,
    CartDetailSortField,
    CartDetailSortField.linesCount
  );

  const paramsCustomer: CartCustomerQueryParams = asSortParams(
    qs,
    CartDetailCustomerSortField,
    CartDetailCustomerSortField.linesCount
  );

  const handleBack = () => {
    navigate(createOrderUrl);
  };

  return (
    <>
      <Container>
        <AppHeader onBack={handleBack}>
          <MyTypography variant="body3">
            {intl.formatMessage({ defaultMessage: "กลับไป" })}
          </MyTypography>
        </AppHeader>
        <PageHeader
          title={intl.formatMessage({ defaultMessage: "Shopping Cart" })}
        />
        <MyTypography variant="h7" className={classes.header}>
          ตะกร้าของฉัน
        </MyTypography>
        <CartPage params={params} paramsCustomer={paramsCustomer} />
      </Container>
    </>
  );
};

export default CartView;
